import { Hubs, HubSplitSectionContent as SplitSectionContent, HubSplitSectionContentType } from 'utils/gloo-types';
import Markdown from 'components/atoms/Markdown';
import HubImageContent from './HubImageContent';

interface HubSplitSectionContentProps {
  hub: Hubs;
  content: SplitSectionContent;
  sectionTitle?: string;
}

const HubSplitSectionContent = ({ hub, content, sectionTitle }: HubSplitSectionContentProps) => {
  let contentComponent: JSX.Element;
  switch (content.type) {
    case HubSplitSectionContentType.IMAGE: {
      contentComponent = (
        <HubImageContent hub={hub} title={sectionTitle} imageUrl={content.imageUrl} linkUrl={content.linkUrl} />
      );
      break;
    }
    case HubSplitSectionContentType.TEXT:
      contentComponent = (
        <span style={{ color: content.textColor }} className="font-normal text-base leading-relaxed">
          <Markdown defaultStyles={false} content={content.text} className="md-render" />
        </span>
      );
      break;
  }
  return <div className="w-full">{contentComponent}</div>;
};

export default HubSplitSectionContent;
